var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('keep-alive',[_c('router-view'),_c('loading')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }